import React, { useEffect, useRef, useState } from "react";
import styled from "styled-components";
import { useTheme } from "@mui/material/styles";

const StyledCarouselContainer = styled.div`
  width: 100%;
  flex-grow: 1;
  overflow: hidden;
  display: flex;
  flex-direction: column;
`;

const StyledSlidesContainer = styled.ul`
  width: 100vw;
  margin: 0;
  padding: 0;
  list-style: none;
  white-space: nowrap;
  flex-grow: 1;
`;

const StyledCarouselItem = styled.li`
  display: inline-block;
  width: 90vw;
  box-sizing: border-box;
  height: 100%;
  margin-left: 1vw;
  margin-right: 1vw;
  position: relative;
`;

const BulletsContainer = styled.ul`
  display: flex;
  justify-content: center;
  list-style: none;
  padding: 0;
  margin: 0;
  margin-top: 12px;
  margin-bottom: 12px;
`;

const Bullet = styled.li`
  width: 3vw;
  height: 3vw;
  border-radius: 1.5vw;
  margin-right: 2vw;
  border-radius: 50%;
  margin: 5px;
  background-color: ${(props) => {
    console.log("Bullet", props);
    return props.backgroundColor;
  }};
  &.selected-bullet {
    background-color: ${(props) => {
      console.log("Bullet", props);
      return props.selectedColor;
    }};
  }
`;

// The slider:
export default ({ children, bullets, onChange, onUpdate }) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [dragging, setDragging] = useState(false);
  const [pos, setPos] = useState({ x: 0, y: 0 });
  const [rel, setRel] = useState({});
  const ref = useRef();
  const { palette } = useTheme();

  useEffect(() => {
    updatePosition();
  }, [currentIndex]);

  useEffect(() => {
    const positions = children.map((child, index) => {
      const p = getPositionByIndex(index);
      const pct = ((pos.x - p.x + 92) / 184) * 100;
      return pct;
    });
    if (onUpdate) {
      onUpdate(positions);
    }
  }, [pos]);

  const changeSlide = (index) => {
    setCurrentIndex(index);
    if (onChange) {
      onChange(index);
    }
  };

  const onMouseDown = (e) => {
    console.log("Mouse event", e, ref);

    const pos = {
      left: ref.current.offsetLeft,
      top: ref.current.offsetTop,
    };

    const x = e.pageX || e.nativeEvent.touches[0].pageX;
    const y = e.pageY || e.nativeEvent.touches[0].pageY;

    setDragging(true);
    setRel({
      x: x - pos.left,
      y: y - pos.top,
    });

    //e.stopPropagation()
    //e.preventDefault()
  };

  const updatePosition = () => {
    const p = getPositionByIndex(currentIndex);
    setPos({ x: p.x });
  };

  const getPositionByIndex = (index) => {
    const p = {
      x: -(index * 90 - 4 + index * 2),
      y: 0,
    };
    return p;
  };

  const swipeRight = () => {
    console.log("Swipe right", currentIndex);
    if (currentIndex > 0) {
      changeSlide(currentIndex - 1);
    }
  };

  const swipeLeft = () => {
    if (currentIndex < children.length - 1) {
      changeSlide(currentIndex + 1);
    }
  };

  const onMouseUp = (e) => {
    setDragging(false);
    const ratio = 100 / window.innerWidth;

    const p = getPositionByIndex(currentIndex);
    // If we move more than 20 vw, go to next:
    const diff = p.x - pos.x;

    if (rel && Math.abs(diff) > 20) {
      diff < 0 ? swipeRight() : swipeLeft();
    }

    // Reset position:
    updatePosition();

    //e.stopPropagation()
    //e.preventDefault()
  };

  const onMouseMove = (e) => {
    if (!dragging) return;
    const x = e.pageX || e.nativeEvent.touches[0].pageX;
    const y = e.pageY || e.nativeEvent.touches[0].pageY;

    const ratio = 100 / window.innerWidth;
    const diff = (x - rel.x) * ratio;
    const p = getPositionByIndex(currentIndex);

    setPos({
      x: diff + p.x,
    });

    e.stopPropagation();
    e.preventDefault();
  };

  let style = {
    transform: `translate(${pos.x}vw, 0px)`,
  };

  return (
    <StyledCarouselContainer>
      <StyledSlidesContainer
        style={style}
        onTouchStart={onMouseDown}
        onTouchEnd={onMouseUp}
        onTouchMove={onMouseMove}
        onMouseDown={onMouseDown}
        onMouseUp={onMouseUp}
        onMouseMove={onMouseMove}
        innerRef={ref}
      >
        {children}
      </StyledSlidesContainer>
      {bullets && (
        <BulletsContainer>
          {children.map((child, index) => {
            return (
              <Bullet
                selectedColor={palette.secondary.main}
                backgroundColor={palette.primary.light}
                className={index == currentIndex ? "selected-bullet" : ""}
                onClick={() => setCurrentIndex(index)}
              />
            );
          })}
        </BulletsContainer>
      )}
    </StyledCarouselContainer>
  );
};

const CarouselItem = (props) => {
  return <StyledCarouselItem {...props} />;
};

export { CarouselItem };
